module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "INTRODUCTION"
    }
  }, [_c('h1', {
    staticClass: "ctl",
    attrs: {
      "id": "p0009-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter2#p0007-P-1"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "txll"
  }, [_c('span', [_vm._v(".......................................................................................")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('span', [_c('em', [_c('a', {
    attrs: {
      "href": "#/chapter2#p0007-P-1"
    }
  }, [_vm._v("The Jesus Story ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0009-02-1"
    }
  }, [_c('span', [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CCORDING "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("TO")]), _vm._v(" ESTIMATES, "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("APPROXIMATELY")]), _vm._v(" 1.25 BILLION")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTIANS")]), _vm._v(" live in the world today. Many, if not most, have become overly familiar with their Bibles. The same can be said about how they view the Lord Jesus Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-03-3"
    }
  }, [_c('span', [_vm._v("A daring statement, you say? Perhaps. How can the two of us think that Christianity has become overfamiliar with the most influential person who ever lived, the most important person who ever walked planet Earth?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-04-5"
    }
  }, [_c('span', [_vm._v("As you read this book, we hope you will come to the same conclusion. Better still, when you finish, we expect you will encounter the Scriptures in a fresh way. And as a result, you will encounter your Lord anew as well. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-04-6"
    }
  }, [_c('span', [_vm._v("Let’s face it. The Bible is often viewed as a disjointed array of stories, events, laws, propositions, truths, ethical statements, and moral lessons.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-05-8"
    }
  }, [_c('span', [_vm._v("But as we will demonstrate in this book, the sixty-six books of the Bible are woven together by a single storyline. One of the best ways to look at the twenty-seven books of the New Testament may be to see them as a commentary on the Old Testament. The entire Scriptures, both Old and New Testaments, are unified by a common narrative. And once our eyes are opened to see that narrative, everything in both Testaments gels into a coherent, understandable, and amazing story.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-2"
    }
  }, [_c('span', [_vm._v("And what is that story? Well, it’s not enough to call it “salvation history” as many people do."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt1",
      "id": "sn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-03-3"
    }
  }, [_c('span', [_vm._v("No. "), _c('em', [_vm._v("It’s the story of Jesus Christ.")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt2",
      "id": "sn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-04-4"
    }
  }, [_c('span', [_vm._v("The end product of biblical Christianity is a person—not a book, not a building, not a set of principles or a system of ethics—but one person in two natures (divine/human) with four ministries (prophet/priest/king/sage) and four biographies (the Gospels). But those four biographies don’t tell the whole story. Every bit of Scripture is part of the same great story of that one person and that one story’s plotline of creation, revelation, redemption, and consummation.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_01",
      "role": "doc-chapter",
      "title": "TOWARD A NEW KIND OF BIOGRAPHY"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "p0010-05-6"
    }
  }, [_c('span', [_vm._v("TOWARD A NEW KIND OF BIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0010-06-7"
    }
  }, [_c('span', [_vm._v("Writing about Jesus is like matrimony: not to be entered into unprepared or lightly, but reverently, discreetly, advisedly, soberly, and in awe of God. Not to mention that over the last fifty years, there have been countless books telling, retelling, and reconstructing the life of Jesus of Nazareth."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt3",
      "id": "sn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" In fact, there are more biographies of Jesus than of any other human—one hundred thousand biographies in English alone."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt4",
      "id": "sn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-07-8"
    }
  }, [_c('span', [_vm._v("So why this book?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-08-10"
    }
  }, [_c('span', [_vm._v("First, this isn’t a biography. It’s a theography. Even if you argue that a biography of Jesus is possible, which is hotly debated among scholars today,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt5",
      "id": "sn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" we are telling the story of God’s interactions, intersections, and interventions with humanity through the life of Jesus. We are less concerned with every fact and detail of Jesus’ life than we are about the narratives, metaphors, signs, and symbols that reveal pictures of God’s touching of humanity through the person and identity of Jesus. In each major scene in the Jesus story, we try to provide “snapshots”—organic freeze-frames and visual markers of Jesus in living color and surround sound to be experienced, breathed, and lived by our readers.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-09-12"
    }
  }, [_c('span', [_vm._v("This book lifts up the epic story of Jesus as the single, ascertainable truth that triumphs over all other contingent truths. In other words, human identity is bound up with the story of an individual and the story of a community. In a world that tries to snatch an identity off the racks of an Armani store, or from the marble floor of a "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("BMW")]), _vm._v(" showroom, we believe that humanity was created to find its identity in a relationship with God. The story of Jesus as found in the Bible shows us how to do that. Neither of us wants to bend the world to see things through our eyes. But we do want to entice the world to see things through Jesus’ eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-2"
    }
  }, [_c('span', [_vm._v("Virtually every biography of Jesus begins with the nativity account in Bethlehem."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt6",
      "id": "sn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" The Jesus theography you hold in your hands begins the story of Jesus at “the beginning.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt7",
      "id": "sn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_02",
      "role": "doc-chapter",
      "title": "FROM ETERNITY PAST TO THE SECOND COMING"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "p0011-03-3"
    }
  }, [_c('span', [_vm._v("FROM ETERNITY PAST TO THE SECOND COMING ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0011-04-4"
    }
  }, [_c('span', [_vm._v("According to Scripture, the Jesus story doesn’t begin in Bethlehem or Nazareth. It begins in eternity past, when the Word (Jesus in His preincarnate state) “was with God, and . . . was God.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt8",
      "id": "sn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" So we will tell the Jesus story, not “from the womb to the tomb,” but from eternity past (as the preexistent Son) to His second coming (as the postresurrected, risen Lord)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt9",
      "id": "sn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-05-5"
    }
  }, [_c('span', [_vm._v("In addition, we will rehearse the story of Jesus—the greatest story ever told—by following the plotline that stretches from Genesis to Revelation. And we will demonstrate that all the Scriptures are held together by a single narrative: the story of Jesus Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt10",
      "id": "sn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-06-6"
    }
  }, [_c('span', [_vm._v("The name Jesus refers to the incarnate Christ who had a human nature. As such, the name Jesus doesn’t appear in Genesis or elsewhere in the Old Testament. But that doesn’t mean He wasn’t present as the preexistent Son through whom, by whom, and to whom all things were created."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt11",
      "id": "sn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" So in this book, we will use the terms "), _c('em', [_vm._v("Jesus")]), _vm._v(", "), _c('em', [_vm._v("Christ")]), _vm._v(", and "), _c('em', [_vm._v("Son of God ")]), _vm._v("interchangeably in a nontechnical way."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt12",
      "id": "sn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" They all refer to the same person. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-06-7"
    }
  }, [_c('span', [_vm._v("As far as we know, there is no biography of Jesus that tells His story from Genesis to Revelation. If this is correct, one may ask, “Why hasn’t a book like this been written before?” The reason is simple. Biographies of Jesus have generally been written by those trying to investigate the historical Jesus. In general, such people aren’t interested in looking at Jesus in the entire biblical canon. On the flip side, those interested in tracing the biblical narrative from Genesis to Revelation are typically disinterested in historical Jesus studies. So these two approaches have yet to converge."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt13",
      "id": "sn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-1"
    }
  }, [_c('span', [_vm._v("That’s where this book comes in. It brings together historical Jesus studies with a survey of the entire biblical canon."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt14",
      "id": "sn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" In so doing, it seeks to reclaim the Jesus-shaped narrative of Scripture."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt15",
      "id": "sn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_03",
      "role": "doc-chapter",
      "title": "THE CORE NARRATIVE"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "P0012-03-2"
    }
  }, [_c('span', [_vm._v("THE CORE NARRATIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0012-04-3"
    }
  }, [_c('span', [_vm._v("In many Christians’ minds, the Old and New Testaments are two separate entities. Melito (second century) and Tertullian (third century) were the first to call the two halves of the Bible the Old Testament and New Testament."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt16",
      "id": "sn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" However, the Old Testament and the New Testament belong to the same inspired canon. Thus they are organically united. To underscore this unity, we will be calling the Old Testament the "), _c('em', [_vm._v("First ")]), _c('em', [_vm._v("Testament ")]), _vm._v("and the New Testament the "), _c('em', [_vm._v("Second Testament ")]), _vm._v("throughout this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-05-5"
    }
  }, [_c('span', [_vm._v("In our experience and observation, countless evangelical, postevangelical, Reformed, charismatic, and mainline Christians are not aware that the main subject of the "), _c('em', [_vm._v("entire ")]), _vm._v("First Testament is Jesus Christ. But consider what Jesus Himself said about the Scriptures: “You search the Scriptures because you think they give you eternal life. But the Scriptures point to me!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt17",
      "id": "sn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-06-6"
    }
  }, [_c('span', [_vm._v("It is for this reason that statements such as “according to the prophets,” “as it is written,” “according to the Scriptures,” “that the Scripture might be fulfilled,” and “in all the Scriptures” are peppered throughout the entire Second Testament. What is more, the Second Testament authors consistently interpreted the First Testament writings in the light of Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt18",
      "id": "sn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-07-7"
    }
  }, [_c('span', [_vm._v("Many believe that the Second Testament writers simply used parts of the First Testament as proof texts to show that Jesus of Nazareth was the promised Messiah of Israel and Lord of the world. But this is not the case."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt19",
      "id": "sn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-08-8"
    }
  }, [_c('span', [_vm._v("The Second Testament writers consistently quoted or cited large sections of the First Testament, using them to unfold the Jesus story."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt20",
      "id": "sn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" But that’s not all. The Second Testament authors used the "), _c('em', [_vm._v("same ")]), _vm._v("First Testament texts "), _c('em', [_vm._v("independently ")]), _vm._v("of one another. And they interpreted them in exactly the same way, often citing the texts in the same order."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt21",
      "id": "sn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-P-1"
    }
  }, [_c('span', [_vm._v("This fact alone demonstrates that the Second Testament authors shared a common method of interpreting the First Testament. The questions emerge, then: "), _c('em', [_vm._v("Where did they find this method of interpretation? ")]), _c('em', [_vm._v("What was their common source?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-2"
    }
  }, [_c('span', [_vm._v("The answer is that Jesus Himself was the common source."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt22",
      "id": "sn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_04",
      "role": "doc-chapter",
      "title": "JESUS REVEALED THROUGH THE SCRIPTURES"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "P0013-03-3"
    }
  }, [_c('span', [_vm._v("JESUS REVEALED THROUGH THE SCRIPTURES ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0013-04-4"
    }
  }, [_c('span', [_vm._v("The Gospels tell us that Jesus took His followers through the Scriptures and gave them a divinely inspired hermeneutic (method of interpretation) by which to understand the First Testament. In turn, the Lord’s original disciples passed this interpretative key to those whom they influenced (this would include people such as Mark, Paul, and Luke).")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-05-6"
    }
  }, [_c('span', [_vm._v("Luke suggested this in his gospel when he rehearsed Jesus’ encounter with two disciples on the road to Emmaus:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0013-06-8"
    }
  }, [_c('span', [_vm._v("Then beginning with Moses and with all the prophets, He explained to them the things concerning Himself in all the Scriptures."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt23",
      "id": "sn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-07-9"
    }
  }, [_c('span', [_c('br'), _vm._v("Note the words “all the Scriptures.” This includes the First Testament—Genesis through Malachi. They said to one another, “Were not our hearts burning within us while He was speaking to us on the road, while He was explaining the Scriptures to us?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt24",
      "id": "sn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Luke went on to say that Jesus opened the Scriptures to His disciples: “Now He said to them, ’These are My words which I spoke to you while I was still with you, that all things which are written about Me in the Law of Moses and the Prophets and the Psalms must be fulfilled.’ Then He opened their minds to understand the Scriptures.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt25",
      "id": "sn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-08-10"
    }
  }, [_c('span', [_vm._v("In this passage, Jesus unveils Himself through the three parts of the Hebrew Bible: (1) the law of Moses (the Torah); (2) the Prophets (the Nevi’im); and (3) the Psalms, which represent the Writings (the Ketuvim). These three sections make up the "), _c('em', [_vm._v("Tanakh")]), _vm._v("—the rabbinic name for the Hebrew Bible."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt26",
      "id": "sn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" The way the Second Testament authors quoted the First Testament forms a pattern—a shared hermeneutic for understanding the First Testament.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-2"
    }
  }, [_c('span', [_vm._v("It is easy to see, then, that the source of this common hermeneutic was Jesus Himself. Jesus taught His disciples how to understand the Hebrew Scriptures, and this is reflected throughout the Second Testament."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt27",
      "id": "sn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-03-3"
    }
  }, [_c('span', [_vm._v("Jesus’ use of the First Testament text was revolutionary for His time. As R. T. France points out, Jesus “applied the Old Testament in a way that was quite unparalleled. The essence of his new application was that he saw the fulfillment of the predictions and foreshadowings of the Old Testament in himself and his work.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt28",
      "id": "sn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" The early Christian church “was founded on this distinctive and revolutionary use of the Old Testament”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt29",
      "id": "sn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v("—a usage that was handed down to the apostles by Jesus Himself. Jesus clearly said that He was the fulfillment of the entire Hebrew Bible (represented by the Torah, the Writings, and the Prophets)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt30",
      "id": "sn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i",
    attrs: {
      "id": "p0014-04-4"
    }
  }, [_c('span', [_vm._v("If you believed Moses, you would believe Me; for he wrote about Me."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt31",
      "id": "sn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i",
    attrs: {
      "id": "p0014-05-5"
    }
  }, [_c('span', [_vm._v("Do not think that I came to destroy the Law or the Prophets. I did not come to destroy but to fulfill."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt32",
      "id": "sn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-06-6"
    }
  }, [_c('span', [_vm._v("Consider this question with these texts in mind: If you were to ask Jesus what the Scriptures were about, what would His answer be?"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt33",
      "id": "sn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-07-7"
    }
  }, [_c('span', [_vm._v("R. T. France comments, “Jesus saw his mission as the fulfillment of the Old Testament Scriptures; not just of those which predicted a coming redeemer, but of the whole sweep of Old Testament ideas.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt34",
      "id": "sn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" In this regard, Jesus not only "), _c('em', [_vm._v("completes ")]), _vm._v("the First Testament story; He "), _c('em', [_vm._v("fulfills ")]), _vm._v("it. But fulfilling doesn’t happen only in view of the accomplishment of its promises. As you will discover in this book, Jesus actually "), _c('em', [_vm._v("embodies ")]), _vm._v("the First Testament. He “fills full” the ancient Text."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt35",
      "id": "sn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-08-8"
    }
  }, [_c('span', [_vm._v("In a word, Jesus is the thread that holds all Scripture together. He is the prism that breaks forth its multifaceted colors. He is the lens that puts all of it into focus, the switch that sheds light on its dimly lit quarters, and the key that unlocks its meaning and richness."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt36",
      "id": "sn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', [_vm._v("We agree with a long tradition of theologians who do not view the Scriptures as a storehouse of propositions on every imaginable subject but instead discover the place from which the Spirit of God makes Christ known."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt37",
      "id": "sn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Or as Protestant Reformer Martin Luther has put in epigrammatic fashion: “Scripture is the cradle in which Christ lies.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt38",
      "id": "sn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Scot McKnight puts it in more current form: “We have to become a People of the Story . . . we need to immerse ourselves even more into the Story of Jesus. The gospel is that the Story of Israel comes to its definitive completeness in the Story of Jesus, and this means we have to become People of the Story-that-is-complete-in-Jesus.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt39",
      "id": "sn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-1"
    }
  }, [_c('span', [_vm._v("Our desire is to tell that story.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_05",
      "role": "doc-chapter",
      "title": "READING SCRIPTURE AS A WHOLE"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "P0015-03-3"
    }
  }, [_c('span', [_vm._v("READING SCRIPTURE AS A WHOLE ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0015-04-4"
    }
  }, [_c('span', [_vm._v("Given what we have established so far, the approach we are taking to the Scriptures is both holistic as well as reductionist. It is reductionist in that we are drawing from the best findings of modern historical research."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt40",
      "id": "sn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Yet it’s holistic in that we are bringing the First Testament stories, events, and accounts into the core narrative of Jesus—just as the Second Testament writers did when they interpreted the First Testament."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt41",
      "id": "sn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" We are searching for the story the Gospels tell about Jesus in the story found in the First Testament.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-6"
    }
  }, [_c('span', [_vm._v("The Bible didn’t emerge out of a vacuum. It is a historical but also metaphorical and narrative story of truth written within history. Thus, history matters in our interpretation of the biblical text. At the same time, the Bible is a collection of writings that are tied together by a common theme. Therefore, the interweaving of both Testaments also matters in our interpretation of the biblical text.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-06-8"
    }
  }, [_c('span', [_vm._v("To use a metaphor, we are not only inspecting each tree in the forest (the reductionist approach) but also stepping away from the trees to view the entire landscape at high altitude, making note of how each tree connects with the others in an ecosystem (the holistic approach)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt42",
      "id": "sn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" And further, we reveal how we see that forest as nourishing, creative, life-giving, revelatory, and beautiful.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-07-10"
    }
  }, [_c('span', [_vm._v("To put it another way, the Bible contains its own hermeneutic."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt43",
      "id": "sn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" As usual, Augustine has put it best: “In the Old Testament, the New is concealed; in the New, the Old is revealed.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt44",
      "id": "sn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" This being so, the Holy Spirit often had an intention in Scripture that went beyond its authors’ present knowledge."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt45",
      "id": "sn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-1"
    }
  }, [_c('span', [_vm._v("Understanding the author’s intent in a given portion of Scripture is certainly part of the task of biblical interpretation. But it’s not the whole task. As you read this book, this fact will become abundantly clear. The Second Testament authors “remain true to the main intention” of the First Testament authors."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt46",
      "id": "sn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" But they go beyond that intention to the Spirit-inspired meaning found in Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt47",
      "id": "sn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-03-2"
    }
  }, [_c('span', [_vm._v("In our theographical snapshots, we will be employing the same method of interpretation that the Second Testament writers used in their interpretation of the First Testament—a method given to them by Jesus Himself. This method of interpretation safeguards us from entertaining subjective, fanciful, and forced allegorical interpretations on the one hand"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt48",
      "id": "sn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" and completely missing Christ in the sacred Text on the other."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt49",
      "id": "sn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-04-3"
    }
  }, [_c('span', [_vm._v("Again, the Scriptures are not a library of disjointed, independent, inspired books. The First and Second Testaments are not two separate books bound together between a single cover. Rather, they are a unified canon. All the books of that canon contribute to the plotline of God’s covenantal relationship with humanity through Jesus. You can think of the First and Second Testaments as act 1 and act 2 of the same drama. Each book, therefore, must be understood and interpreted within the framework of the greater whole."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt50",
      "id": "sn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-05-4"
    }
  }, [_c('span', [_vm._v("Jesus Christ is the glue that binds both Testaments together. As Brevard Childs says, “The completely New of the gospel is formulated in terms of the Old. Herein lies the deep mystery surrounding the two testaments. Separate and yet undivided, two voices yet the sound is similar, an Old Word pointing to the New, yet the New is only known in the Old.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt51",
      "id": "sn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-06-5"
    }
  }, [_c('span', [_vm._v("That said, it’s a profound mistake to detach Scripture—both First and Second Testaments—from Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt52",
      "id": "sn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" The Bible has no real meaning unless it is grounded in Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt53",
      "id": "sn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" The beauty of Scripture for followers of Jesus is to reveal Christ.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_06",
      "role": "doc-chapter",
      "title": "THE WITNESS OF THE SECOND TESTAMENT AUTHORS"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "P0017-01-0"
    }
  }, [_c('span', [_vm._v("THE WITNESS OF THE SECOND "), _c('br'), _vm._v(" TESTAMENT AUTHORS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0017-02-1"
    }
  }, [_c('span', [_vm._v("Here are just a few samples of how the authors of the Second Testament read the First Testament in the light of Christ:")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-03-3"
    }
  }, [_c('span', [_vm._v("Matthew quoted Hosea about a prophecy concerning Israel: “Out of Egypt I called My Son.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt54",
      "id": "sn54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" But Matthew located its fulfillment in Jesus. He drew similar connections throughout his gospel."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt55",
      "id": "sn55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-04-4"
    }
  }, [_c('span', [_vm._v("John informed us that Philip declared Jesus to be the fulfillment of the Law and the Prophets: “We have found Him of whom Moses in the law, and also the prophets, wrote—Jesus of Nazareth, the son of Joseph.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt56",
      "id": "sn56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-05-5"
    }
  }, [_c('span', [_vm._v("John applied words from Isaiah to Jesus, equating Christ with “the arm of the Lord.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt57",
      "id": "sn57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" John’s gospel is full of references showing how Jesus fulfills the images and events of the First Testament and of the Jewish messianic expectation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt58",
      "id": "sn58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txa",
    attrs: {
      "id": "p0017-06-6"
    }
  }, [_c('span', [_vm._v("According to Paul, one cannot understand the First Testament except in Christ. Jesus is the key that unlocks its meaning."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt59",
      "id": "sn59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Three quick examples: ")])]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_c('span', [_vm._v("1. Paul stated that Adam is an image, or a model, of Jesus."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt60",
      "id": "sn60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_c('span', [_vm._v("2. Paul argued that Israel’s festivals and food laws are embodied in Christ. They are mere shadows that point to Jesus, the reality."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt61",
      "id": "sn61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_c('span', [_vm._v("3. Paul said the rock that followed Israel represents Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt62",
      "id": "sn62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0017-08-9"
    }
  }, [_c('span', [_vm._v("Paul’s epistles are rife with these kinds of connections.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-09-11"
    }
  }, [_c('span', [_vm._v("The writer of Hebrews took a promise that God gave to King David and applied it to Jesus."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt63",
      "id": "sn63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" He also stated that the Law foreshadowed what was in the new covenant: namely, Jesus Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt64",
      "id": "sn64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" This is a major theme throughout the book of Hebrews.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-10-13"
    }
  }, [_c('span', [_vm._v("According to Peter, the prophets spoke of the sufferings and glories of Christ in ways that they themselves didn’t fully understand."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt65",
      "id": "sn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Peter applied the words of Isaiah about a stone lying in Zion to Jesus."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt66",
      "id": "sn66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-11-14"
    }
  }, [_c('span', [_vm._v("In like manner, the church fathers, the Reformers, and countless theologians and scholars of the past and present all testify to this same understanding of the First Testament. With a united voice, they declared that Jesus is the interpretative key of the Bible. (In the appendix, we give a sampling of these post-apostolic witnesses.)")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-P-1"
    }
  }, [_c('span', [_vm._v("To put it in a sentence:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1i",
    attrs: {
      "id": "p0018-02-3"
    }
  }, [_c('span', [_vm._v("In Jesus the promise is confirmed, the covenant is renewed, the prophecies are fulfilled, the law is vindicated, salvation is brought near, sacred history has reached its climax, the perfect sacrifice has been offered and accepted, the high priest over the household of God has taken his seat at God’s right hand, the Prophet like Moses has been raised up, the Son of David reigns, the kingdom of God has been inaugurated, the Son of Man has received dominion from the Ancient of Days, the Servant of the Lord, having been smitten to death for his people’s transgression and borne the sin of many, has accomplished the divine purpose, has seen light after the travail of his soul, and is now exalted and extolled and made very high."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt67",
      "id": "sn67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-03-4"
    }
  }, [_c('span', [_vm._v("Many who have rightly taught that Jesus is the hermeneutical key to the Bible have failed to look at "), _c('em', [_vm._v("all ")]), _vm._v("Scripture through the lens of Christ. What we will demonstrate in this book is that everything in the Bible points to Jesus—either His person, His work, or His character.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-04-6"
    }
  }, [_c('span', [_vm._v("When we fail to see the entire Bible christologically and theographically, the door is opened for the Bible to take on a raft of contradictory interpretations. We believe, therefore, that failure to read the Bible christologically is the cause for the countless divisions among Christians. The internal unity of the Bible is its witness to Jesus. He is the Canon within the canon.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-05-8"
    }
  }, [_c('span', [_vm._v("Reading Scripture through a christological and theographical lens is more radical a move than we might think at first blush. In our observation, it’s rarely practiced today—even among those who claim to uphold the centrality of Christ. It’s one thing to "), _c('em', [_vm._v("profess ")]), _vm._v("to read the Scripture christologically or to agree with it in "), _c('em', [_vm._v("principle")]), _vm._v(". But it’s quite another to actually "), _c('em', [_vm._v("practice ")]), _vm._v("it.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-06-10"
    }
  }, [_c('span', [_vm._v("Many Christians read the Bible with modern or postmodern optics, then clip on “Christocentrism” sunglasses. But reading Scripture through a christological lens changes the way we see and approach the entire Bible, as well as how we regard and handle biblical doctrine."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt68",
      "id": "sn68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" It also prevents us from making the common mistake of missing the drama for the details. Reading Scripture christologically turns Bible reading from two dimensions into 3-D. It transforms it from black-and-white into high-definition Technicolor. We are confident that as you read this book, you will better understand what we mean.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_07",
      "role": "doc-chapter",
      "title": "TOWARD A TRUE RED-LETER BIBLE"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "P0019-02-2"
    }
  }, [_c('span', [_vm._v("TOWARD A TRUE RED-LETER BIBLE ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0019-03-3"
    }
  }, [_c('span', [_vm._v("Many Christians grew up reading red-letter editions of the Second Testament. Those are the Bibles wherein the words of Jesus are printed in red. Now imagine a First Testament where every reference, every prophecy, every shadow, every image, and every allusion to Christ appeared in red. If such a red-letter First Testament existed, it would glow in the dark. And if Jesus is YHWH,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt69",
      "id": "sn69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" as Dietrich Bonhoeffer, N. T. Wright, Scot McKnight, Richard Bauckham, and others have argued, then it could light up a living room."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt70",
      "id": "sn70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-04-4"
    }
  }, [_c('span', [_vm._v("As you read this book, we want you to remember the image of a red-letter Bible in which all the letters are red. The reason is because the story of Scripture is the story of Jesus. All of it, therefore, should appear in red."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt71",
      "id": "sn71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-05-5"
    }
  }, [_c('span', [_vm._v("In this connection, the Bible was written in a narrative arc that ends where it began. In other words, biblical logic defies logic. The Bible was written in a circle.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-06-7"
    }
  }, [_c('span', [_vm._v("For the Western mind, this is hard to hear. As the old joke goes, two Christians were once talking about their pastors. The first one bragged, “My pastor’s good at foreign languages—he uses Greek a lot.” The second one said, “My pastor’s good at geometry—he talks in circles a lot.” To say that someone “talks in circles” is not a compliment. Yet recent anthropological study and literary scholarship have revealed that when the spoken word became the written word, when bards turned into scribes, the resulting texts were written in a lost art of symmetry and elegance that is now called “ring composition.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt72",
      "id": "sn72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Not just the Hebrew Bible, but ancient literature in India, Homer’s narratives in Greece, as well as texts found in such disparate places as Egypt, China, Indonesia, and Russia, were written in nonlinear configurations where the chapters of the story are connected not sequentially but synoptically. It’s not a “story-line” but a “story-circle,” where the plot relates to what is across the circle from it, not what is before or after it.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-02-2"
    }
  }, [_c('span', [_vm._v("The three main features of ring composition are (1) parallelism, (2) chiasmus, and (3) latch. We are most familiar with "), _c('em', [_vm._v("parallelism")]), _vm._v(", where each section mirrors what is across the circle and is often marked by parallel alliteration and resonance. "), _c('em', [_vm._v("Chiasmus ")]), _vm._v("is the turning point, that place in the narrative arc when a climax of meaning drives a loop back, dividing the circle into halves and overlaying one half on top of the other. The "), _c('em', [_vm._v("latch ")]), _vm._v("is the journey home, back to where you started, that closes the circle, not so much with a conclusion, as with an arrival home, but at a higher level of integration and increased awareness that is transformative and enchanting.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-03-4"
    }
  }, [_c('span', [_vm._v("When humans started writing, why did they write in rings? Because that’s how the brain is hardwired. The brain works through symmetry, balanced proportions, corresponding repetition, and parallelisms, just like ring composition. Furthermore, ring compositions are shaped not like straight lines or sine curves but like a torus (think spiral donut), the universal form of self-organizing, self-regulating, self-organizing systems. One more thing: our ancestors wrote stories as the universe moved, not in linear progression but in circles. A story that doesn’t build step-by-step, chapter by chapter, book by book, but reaches a climax by syntactical rules that form relationships between parallel rungs of the text, appears odd to people used to linear storytelling.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-04-6"
    }
  }, [_c('span', [_vm._v("Ring composition forces one to slow down and pay attention to the details while never losing sight of the whole. It is natural, then, that the most relational book ever written should be written in this relational and beautiful symmetry. And our theography will attempt to draw attention to those rings.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_08",
      "role": "doc-chapter",
      "title": "THREE KEY POINTS"
    }
  }, [_c('h2', {
    staticClass: "h1c",
    attrs: {
      "id": "P0020-05-8"
    }
  }, [_c('span', [_vm._v("THREE KEY POINTS ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0020-06-9"
    }
  }, [_c('span', [_vm._v("In closing, we want to leave you with three key points about this book. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-06-10"
    }
  }, [_c('span', [_vm._v("First, "), _c('em', [_vm._v("this book is primarily written for a Christian audience. ")]), _vm._v("Thus, when we use the words “we” and “us,” we are referring either to ourselves (the authors) or to all followers of Jesus—what the Second Testament calls disciples of Jesus—those who trust in and share in the life of Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', [_vm._v("There is a sign as you enter the Louvre Museum: “You do not judge the paintings; they judge you.” Part of the difference between a biography and a theography is that you move away from a critical stance and reposition yourself to be critiqued by the truthfulness and authority of the entire biblical canon. This repositioning also involves trusting the historical authenticity of the Hebrew Scriptures, the Gospels, the Epistles, and Revelation as they present the story of Jesus."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt73",
      "id": "sn73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-1"
    }
  }, [_c('span', [_vm._v("“All Scripture is given by inspiration of God” (or more poetically, “God-breathed”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt74",
      "id": "sn74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(") is the famous phrasing of 2 Timothy 3:16. This mixture of terms is not found in any previously composed biblical text. Paul coined a new term to convey how important it is to comprehend the authoritative nature of all the Hebrew Scriptures and to contend that they all interpret and illumine the gospel of Jesus Christ."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt75",
      "id": "sn75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-03-2"
    }
  }, [_c('span', [_vm._v("Consequently, the Bible is an organic, living document. As with every living organism, everything is connected to everything else. You can start anywhere and get everywhere. Each verse is a doorway or dormer that can lead into other venues that have their own portals into God’s presence. The whole Bible is a beautiful, intricately woven tapestry—or in digital terms, a measureless interconnected network—where unexpected similarities, surprising parallels, and profound paradoxes can be found. It was this kind of intimacy with the Bible that Jesus the Jew manifested in almost everything that proceeded out of His mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-04-4"
    }
  }, [_c('span', [_vm._v("When we interpret Scripture, we are not simply interpreting documents as dead objects, as we would analyze the rings in tree stumps. We are engaged in a transaction with a divine book that was coauthored by humans and a divine person who still lives and speaks. Interpreting Scripture, then, is not simply a scientific, secular enterprise. It requires spiritual insight. It mandates a divine imagination. For this reason Paul argued that the “natural man” cannot comprehend the things of the Spirit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt76",
      "id": "sn76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-05-5"
    }
  }, [_c('span', [_vm._v("Jesus is the Logos."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt77",
      "id": "sn77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" He is the Word, or the self-utterance, of God. So when God speaks, it is Christ who is being spoken about. When God breathes, it is Christ who is being imparted. The Spirit is God’s breath (the words “Spirit” and “breath” are the same in both Hebrew and Greek). The Second Testament tells us clearly that the Holy Spirit’s job is to reveal, magnify, and glorify Christ. Thus, because the Bible is inspired, it all speaks of Jesus.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-02-2"
    }
  }, [_c('span', [_vm._v("Again, "), _c('em', [_vm._v("Jesus Christ is the subject of all Scripture")]), _vm._v(". He is the main character of the story. The plot revolves around Him, and the images of Christ are what make the story sing the song of truth. The real and total meaning of Scripture, therefore, is found in Jesus Christ—His person, His mission, and His work. He is the fulfillment of the Torah, the Prophets, and the Writings.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-03-4"
    }
  }, [_c('span', [_vm._v("Regardless of whether you prefer to view the Second Testament references to Christ as allusions, applications, types, signs, allegories, shadows, figures, extended meanings,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt78",
      "id": "sn78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" or the literal meaning of the text, Jesus Christ is the focus of the entire Bible—both First and Second Testaments. This point will become obvious as we move forward in telling the Jesus story.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-04-6"
    }
  }, [_c('span', [_vm._v("Second, when we get to "), _c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4")]), _vm._v(", "), _c('em', [_vm._v("we will begin recounting the story ")]), _c('em', [_vm._v("of Jesus from His birth in Bethlehem until His second coming. ")]), _vm._v("The chronology we will follow is found in Robert Mounce’s classic "), _c('em', [_vm._v("Jesus, In His Own ")]), _c('em', [_vm._v("Words—")]), _vm._v("a chronological blending of the four Gospels."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt79",
      "id": "sn79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" We have been amazed at how many problematic passages in the Gospels suddenly become clear when read in chronological sequence."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt80",
      "id": "sn80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-05-7"
    }
  }, [_c('span', [_vm._v("As we recount Jesus’ life on earth, we will be weaving into it references, images, prophecies, and events from the First Testament to show the unity of Scripture as it concerns Jesus. We hope this effort will bring the First Testament alive for you in fresh ways. Our purpose is to connect the dots of the First Testament to the Second, highlighting the Bible’s unified storyline. Among other things, you will discover that the entire story of Israel in the First Testament "), _c('em', [_vm._v("repeats ")]), _vm._v("itself in the life of Christ in the Second Testament. And it does so in almost every detail."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt81",
      "id": "sn81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" In this regard, Jesus not only fulfills the First Testament narrative but also reenacts, relives, and replays it. This is one of the most fascinating aspects of the Bible.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-06-9"
    }
  }, [_c('span', [_vm._v("At times we will quote the authors of the Second Testament in their use of the First Testament to shed light on the Jesus story. Other times we will simply make references to the First Testament without any such quotations. The reason for this is that not all references and allusions to Jesus in the First Testament are mentioned in the Second Testament. To quote Edmund Clowney (former president of Westminster Theological Seminary), “To conclude that we can never see a type where the New Testament does not identify it is to confess hermeneutical bankruptcy.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt82",
      "id": "sn82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" Yet by following the same line of interpretation that the First Testament authors consistently used in their reading of the Hebrew Scriptures, we can discover Jesus Christ afresh all throughout the Bible.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-02-2"
    }
  }, [_c('span', [_vm._v("Note that if we unveiled all the references, allusions, prophecies, and foreshadowings of Jesus present in the First Testament, this book would be thousands of pages."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt83",
      "id": "sn83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" We are forced to be highly selective in which ones we choose to highlight. Nonetheless, we hope you will pick up the pattern of interpretation we are using so that you may take it from here and find Jesus throughout the rest of the First Testament yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-03-4"
    }
  }, [_c('span', [_vm._v("In a world and a church that has lost the plot of the story and the "), _c('em', [_vm._v("cantus firmus ")]), _vm._v("of the music, we need to reclaim the Bible as a whole narrative telling one fluid, coherent story—the Jesus story. After all, the origin of the word "), _c('em', [_vm._v("gospel ")]), _vm._v("is "), _c('em', [_vm._v("Godspell")]), _vm._v(", or the “story of God.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-04-6"
    }
  }, [_c('span', [_vm._v("Third, "), _c('em', [_vm._v("we are not writing this book for scholars but for the general Christian population")]), _vm._v(". At the same time, we have provided endnotes for the benefit of scholars, academicians, and curious minds who wish to see the sources that have influenced some of our conclusions and to delve deeper into them.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-05-8"
    }
  }, [_c('span', [_vm._v("One of our favorite metaphors for reframing how people see the Bible is to approach it as a movie."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter22#nnt84",
      "id": "sn84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" But not any simple, straightforward movie—one filled with flashbacks, interweaving relationships and plotlines, metaphors and narratives, multiple voices, and circles of meaning, an organic and rich symmetry of dynamic signs, a story that reveals the truth of Jesus Christ in freshness, surround sound, and living color. As with any great story, there are characters, sequence, conflict, climax, and resolution. Unlike any other story, however, this is a never-ending story. This story invites you to become part of it with its main character, who wants to merge His story with yours.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-06-10"
    }
  }, [_c('span', [_vm._v("So sit back, relax, and enjoy the story. Stay in your seat. Sit at its feet. Don’t try to figure everything out or get everything right. Just let the story unfold. Let the Bible tell its own story to you. Trust the Jesus story as it moves from Genesis to Revelation. And see if the Holy Spirit doesn’t open your eyes to see the greatness of Christ anew and afresh.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-1"
    }
  }, [_c('span', [_vm._v("May your heart burn within you while reading it as it has ours while writing it.")])]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "p0024-02-3"
    }
  }, [_c('span', [_vm._v("—Leonard Sweet and Frank Viola ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe32110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 75
// module chunks = 0